enum AssociationType {
    NoAssociation = 1,
    SingleAssociation = 2,
    MultipleAssociations = 3,
    RequiredSingleAssociation = 4,
    MinimumOneRequiredAssociation = 5,
}
export default AssociationType
